import {createReducer, on} from '@ngrx/store';
import {StreamStatus} from '../../services/api/stream-statuses/stream-status.model';
import {
  clearStreamStatusesState,
  loadStreamStatuses,
  loadStreamStatusesFailure,
  loadStreamStatusesSuccess,
  updateStreamStatuses
} from './stream-statuses.actions';


export interface State {
  record: StreamStatus[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


function updateStatuses(
  currentRecords: StreamStatus[],
  newStatuses: StreamStatus[]
): StreamStatus[] {
  return currentRecords
    .map((item: StreamStatus): StreamStatus => {
      const currentStatus: StreamStatus | undefined = newStatuses
        .find((status: StreamStatus): boolean => status.streamId === item.streamId);
      if (currentStatus) {
        return {
          ...item,
          ...currentStatus
        };
      }
      return item;
    });
}

export const streamStatusesReducer = createReducer(
  initialState,

  on(loadStreamStatuses, (state: State, _action): State => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true
  })),
  on(loadStreamStatusesSuccess, (_state: State, action: { data: StreamStatus[] }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(loadStreamStatusesFailure, (_state: State, action: { error: unknown }): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(updateStreamStatuses, (state: State, action: { data: StreamStatus[] }): State => {
    const currentRecords: StreamStatus[] = state.record || [];
    const updatedRecords: StreamStatus[] = updateStatuses(currentRecords, action.data);
    return {
      record: updatedRecords,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(clearStreamStatusesState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false
  }))
);
